import { InjectionToken } from "@angular/core";

/**
 * @type {InjectionToken<FormatterServiceConfig>} DI provider token for {@link FormatterServiceConfig} implementations.
 */
export const FormatterServiceConfigToken: InjectionToken<FormatterServiceConfig> = new InjectionToken<FormatterServiceConfig>("core.formatterserviceconfig");

/**
 * Format service configuration type.
 */
export interface FormatterServiceConfig {
    defaultDateFormat?: string;
    defaultDateTimeFormat?: string;
}
